import Persistable from "../../../storage/persistable";

export default class DefaultTimeEnvironment extends Persistable {
    constructor() {
        super();

        this.timeShift = 0;
    }

    addSeconds(sec) {
        this.timeShift = this.timeShift - sec * 1000;
    }

    relativeDate() {
        const presentTime = new Date();
        return new Date(presentTime - this.timeShift);
    }

    setDate(date) {
        const presentTime = new Date();
        this.timeShift = presentTime - date;
    }

    now() {
        return this.relativeDate();
    }
}
